export const calculatePadding = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const padding = Math.min(width, height) * 0.2;
  return padding;
};
